function Other3(props)
{
    return(
        <svg className={props.class} style={{...props.style}} viewBox="0 0 480 480"><path d="M398.7 240c30.3-26.7 53.8-61 67.6-99.8A60 60 0 1 0 353.2 100a120 120 0 0 1-226.3 0 60 60 0 1 0-113.1 40.1C27.4 179 51 213.2 81.2 240a240.3 240.3 0 0 0-67.6 99.8A60 60 0 1 0 126.8 380a120 120 0 0 1 226.3 0 60 60 0 1 0 113.1-40.1 240.4 240.4 0 0 0-67.5-99.8Z"></path></svg>
    )
}

export default Other3